
































import { Component, Model, Watch, Prop } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'

@Component({
  middleware: async (ctx) => {
    // todo: middleware
  },
  validate: async (ctx) => {
    // todo: validate
    return true
  },
  asyncData: async (ctx) => {
    // todo: asyncData
  },
})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  // #region variables
  @Model('value', { default: null }) value: string
  @Prop({ default: 'date' }) type: string
  @Prop({ default: undefined }) min: string | undefined
  @Prop({ default: undefined }) max: string | undefined
  @Prop({ default: undefined }) inputClass: string | undefined
  @Prop({ default: false }) disabled: boolean
  visible: boolean = false
  date: string = null
  classes: string = undefined
  // #endregion
  // #region hooks
  created() {
    this.date = this.value
    this.classes = this.inputClass
  }
  // #endregion

  // #region methods
  dayFormat(date) {
    return new Date(date).getDate()
  }

  checkDate(date) {
    console.log(date, typeof date)
    return false
  }

  click(result: boolean) {
    this.visible = false

    if (!result) this.date = this.value

    this.$emit('value', this.date)
  }

  beforeDestroy() {
    console.log('Modal beforeDestroy-----------------', document.getElementsByClassName('v-dialog__content--active').length, document.querySelector('html').classList)
    this.$nextTick(function () {
      const modal = document.getElementsByClassName('v-dialog__content--active').length
      if (modal > 0) {
        setTimeout(() => document.documentElement.classList.add('overflow-y-hidden'), 100)
      } else {
        setTimeout(() => document.documentElement.classList.remove('overflow-y-hidden'), 100)
      }
    })
  }
  // #endregion

  // #region watches
  @Watch('value')
  onValueChanged(val: string) {
    this.date = val
  }

  @Watch('visible')
  onVisibleChanged(value: string) {
    if (value) {
      this.$nextTick(function () {
        console.log('Modal -----------------', value, document.getElementsByClassName('v-dialog__content--active').length)
        setTimeout(() => document.documentElement.classList.add('overflow-y-hidden'), 100)
      })
    } else {
      this.$nextTick(function () {
        const modal = document.getElementsByClassName('v-dialog__content--active').length
        console.log('modal', modal)
        if (document.getElementsByClassName('v-dialog__content--active').length > 0) {
          setTimeout(() => document.documentElement.classList.add('overflow-y-hidden'), 100)
        }
      })
    }
  }

  @Watch('max')
  onMaxChanged(val: string) {
    this.max = val
  }

  @Watch('inputClass')
  onClassChanged(val: string) {
    this.classes = val
  }
}
